module.exports = __webpack_public_path__ + "static/media/js.eaf5b9ef.svg";